import axios from 'axios';
import { baseUrl, token } from '../../../services/Apis';
import { CARRERAS_CONST } from '../../sistema/carreras/CarrerasService';

export const PERFILES_CONST = 'perfiles';

export const allPerfilesService = async (params) => {
  const res = await axios.get(`${baseUrl}/${PERFILES_CONST}`, {
    headers: token({}),
    params,
  });
  return res;
};

export const savePerfilesService = async (id, data) => {
  let res;
  if (id) {
    res = await axios.patch(`${baseUrl}/${PERFILES_CONST}/${id}`, data, {
      headers: token({}),
    });
  } else {
    res = await axios.post(`${baseUrl}/${PERFILES_CONST}`, data, {
      headers: token({}),
    });
  }
  return res;
};

export const onePerfilesService = async (id) => {
  const res = await axios.get(`${baseUrl}/${PERFILES_CONST}/${id}`, {
    headers: token({}),
  });
  return res;
};

export const deletePerfilesService = async (id) => {
  const res = await axios.delete(`${baseUrl}/${PERFILES_CONST}/${id}`, {
    headers: token({}),
  });
  return res;
};

export const asignarCarreraPerfilesService = async (idCarrera, idMateria) => {
  const res = await axios.post(
    `${baseUrl}/${CARRERAS_CONST}/${idCarrera}/${PERFILES_CONST}/${idMateria}`,
    {},
    { headers: token({}) },
  );
  return res;
};

export const deleteCarreraPerfilesService = async (idCarrera, idMateria) => {
  const res = await axios.delete(
    `${baseUrl}/${CARRERAS_CONST}/${idCarrera}/${PERFILES_CONST}/${idMateria}`,
    { headers: token({}) },
  );
  return res;
};
